import React from 'react'
import SectionType from 'models/types/ts/sectionType'
import VideoCarousel from 'features/video-carousel'
import style from './VideoGallery.module.scss'

interface Props {
    section: SectionType
    playButtonColor?: string
    color?: string
    CTAButton?: React.ReactNode
}

const VideoGallery = ({
    section,
    playButtonColor = 'red',
    color = '#3399FF',
    CTAButton,
}: Props): JSX.Element => {
    return (
        <div className={style.videoGallery}>
            <div className={style.wrapper}>
                <VideoCarousel
                    section={section}
                    color={color}
                    playButtonColor={playButtonColor}
                    displayHeadingsLine={false}
                    CTAButton={CTAButton}
                />
            </div>
        </div>
    )
}

export default VideoGallery
